import { mapActions } from 'vuex'
import { repairOptionsService } from '@/services/repairOptions-api.service'
import axios from 'axios'

export default {
  computed: {
    // ---------------------------------------------------------//
    // Reseller id from sales system
    // ---------------------------------------------------------//
    resellerId () {
      return process.env.VUE_APP_RESELLER_ID
    },
    // ---------------------------------------------------------//
    // Base url for the api
    // ---------------------------------------------------------//
    baseUrl () {
      return process.env.VUE_APP_API_BASE_URL
    },
    // isLoading () {
    //   return this.$store.state.repairoptions.loading
    // },
    isLoading: {
      get () {
        return this.$store.state.repairoptions.loading
      },
      set (value) {
        this.setLoading(value)
      }
    },
    selectedClaim () {
      return this.$store.state.myclaims.selectedClaim
    },
    claimant () {
      return this.$store.state.myclaims.selectedClaim.claimant
    },
    selectedGadget () {
      return this.$store.state.myclaims.selectedGadget
    },
    selectedGadgetId () {
      let { selectedGadget } = this.$store.state.myclaims
      let { params } = this.$route

      if (selectedGadget) {
        return selectedGadget.id
      }

      if (params) {
        return params.id
      }

      return null
    },
    repairOptionsList () {
      return this.$store.state.repairoptions.repairOptionsList
    },
    selectedRepairOption: {
      get () {
        return this.$store.state.repairoptions.selectedOption
      },
      set (value) {
        this.setSelectedRepairOption(value)
      }
    },
    repairOptionTitle () {
      let { selectedOption } = this.$store.state.repairoptions
      if (selectedOption) {
        return selectedOption.repairOptionWebDisplayTitle
      }
    },
    repairOptionDetails () {
      let { selectedOption } = this.$store.state.repairoptions
      if (selectedOption) {
        return selectedOption.webContentEntityValue
      }
    },
    totalExcess () {
      if (this.$store.state.repairoptions) {
        return this.$store.state.repairoptions.totalExcess
      }

      return 0
    },
    selectedOptionInstructions () {
      let { instructions } = this.$store.state.repairoptions
      if (instructions) {
        return instructions
      }

      let { instructionsHtml } = this.$store.state.myclaims.selectedGadget.repairOption
      if (instructionsHtml) {
        return instructionsHtml
      }
      return null
    },
    // selectedAddress () {
    //   return this.$store.state.repairoptions.selectedAddress
    // },
    selectedAddress: {
      get () {
        return this.$store.state.repairoptions.selectedAddress
      },
      set (value) {
        this.setSelectedAddress(value)
      }
    },
    // modelVersions () {
    //   return this.$store.state.repairoptions.modelVersions
    // },
    modelVersions: {
      get () {
        return this.$store.state.repairoptions.modelVersions
      },
      set (value) {
        this.setModelVersions(value)
      }
    },
    // bookingReference () {
    //   return this.$store.state.repairoptions.bookingReference
    // },
    bookingReference: {
      get () {
        return this.$store.state.repairoptions.bookingReference
      },
      set (value) {
        this.setBookingReference(value)
      }
    },
    bookingDates: {
      get () {
        return this.$store.state.repairoptions.bookingDates
      },
      set (value) {
        this.setBookingDates(value)
      }
    },
    deviceId: {
      get () {
        return this.$store.state.repairoptions.deviceId
      },
      set (value) {
        this.setDeviceId(value)
      }
    },
    booking: {
      get () {
        return this.$store.state.repairoptions.booking
      },
      set (value) {
        this.setBooking(value)
      }
    },
    paymentResponse: {
      get () {
        return this.$store.state.repairoptions.paymentResponse
      },
      set (value) {
        this.setPaymentResponse(value)
      }
    },
    paymentResponseAdvice () {
      if (this.paymentResponse) {
        return this.paymentResponse.paymentAdvice
      }
    },
    // bookingOrderId () {
    //   let { order_id } = this.booking
    //   return order_id
    // },
    gadgetRepairOptionTypeId () {
      let { repairOption } = this.selectedGadget
      if (repairOption != null) {
        let { repairOptionTypeId } = repairOption
        return repairOptionTypeId
      }
      return null
    },
    gadgetRepairBookingReference () {
      let { repairOption } = this.selectedGadget
      if (repairOption != null) {
        let { booking } = repairOption
        if (booking != null) {
          return booking.providerBookingRef
        }
      }
      return null
    },
    gadgetRepairBookingOrderId () {
      let getOrderId = (booking) => {
        if (booking != null) {
          let { providerBookingInfo } = booking
          if (providerBookingInfo != null) {
            let infoJson = JSON.parse(providerBookingInfo)
            if (infoJson != null) {
              return infoJson.order_id
            }
          }
        }
        return null
      }

      let { repairOption } = this.selectedGadget
      if (repairOption != null) {
        let { booking } = repairOption
        return getOrderId(booking)
      } else {
        let { booking } = this.selectedGadget
        return getOrderId(booking)
      }
    },
    hasErrors () {
      return this.errors && this.errors.length > 0
    },
    isStandalone() {
      return process.env.VUE_APP_FORM_TYPE == 'standalone';
    },
    isTiga() {
      return process.env.VUE_APP_FORM_TYPE == 'tiga';
    }
  },
  data: () => {
    return {
      errors: [],
      excessCardDetails: {
        name: '',
        number: '',
        expiryDate: '',
        code: '',
        line1: '',
        line2: '',
        town: '',
        county: '',
        postcode: ''
      },
      showPaymentAdvice: false,
      paymentSuccess: false
    }
  },
  methods: {
    ...mapActions({
      setLoading: 'repairoptions/setLoading',
      loadOptions: 'repairoptions/getRepairOptionsList',
      setSelectedRepairOption: 'repairoptions/setSelectedRepairOption',
      loadSelectedClaim: 'myclaims/getClaimForGadget',
      loadSelectedGadgetFromSelectedClaim: 'myclaims/setSelectedGadgetFromSelectedClaim',
      setInstructions: 'repairoptions/setInstructions',
      setSelectedAddress: 'repairoptions/setSelectedAddress',
      setModelVersions: 'repairoptions/setModelVersions',
      setBookingReference: 'repairoptions/setBookingReference',
      setBookingDates: 'repairoptions/setBookingDates',
      setDeviceId: 'repairoptions/setDeviceId',
      setBooking: 'repairoptions/setBooking',
      setPaymentResponse: 'repairoptions/setPaymentResponse'
    }),
    setRepairOption (gadgetId) {
      this.setLoading(true)

      let opt = {
        ...this.selectedRepairOption,
        gadgetWebRef: gadgetId,
        claimWebRef: this.selectedClaim.id
      }

      repairOptionsService.setRepairOptionForGadget(opt)
        .then(response => {
          this.setRepairOptionResponse = response.data
          if (this.setRepairOptionResponse.success === true) {
            this.setInstructions(this.setRepairOptionResponse.instructionsHTML)
            this.loadSelectedClaim(this.selectedGadgetId)
            this.$router.push({ path: '/myclaims/repairoptions/instructions' })
          } else {

          }
        })
        .catch(() => {
          this.errors.push('Fatal error')
        })
        .finally(() => this.setLoading(false))
    },
    addBankDetailsSetRepairOption (bankDetails) {
      axios
        .post(this.baseUrl + '/api/v1/payment/banktrans/' + this.selectedClaim.id, bankDetails)
        .then(res => {
            let { success } = res.data.data
            if (success == true) {
              let opt = {
                ...this.selectedRepairOption,
                gadgetWebRef: this.selectedGadgetId,
                claimWebRef: this.selectedClaim.id
              }

              repairOptionsService.setRepairOptionForGadget(opt)
                .then(response => {
                  this.setRepairOptionResponse = response.data
                  if (this.setRepairOptionResponse.success === true) {
                    this.setInstructions(this.setRepairOptionResponse.instructionsHTML)
                    this.loadSelectedClaim(this.selectedGadgetId)
                    this.$router.push({ path: '/myclaims/repairoptions/instructions' })
                  } else {
                    this.errors.push('Set repair option error')
                  }
                })
                .catch(() => {
                  this.errors.push('Fatal error')
                })                     
            }
        })
        .catch(err => {
        
        })
      
    },
    payExcessSetRepairOption (gadgetId) {
      this.setLoading(true)
      let paymentDetails = {
        claimWebReference: this.selectedClaim.id,
        gadgetWebReference: gadgetId,
        cardTypeId: this.excessCardDetails.provider,
        cardName: this.excessCardDetails.name,
        cardNumber: this.excessCardDetails.number,
        cardSecurityCode: this.excessCardDetails.code,
        cardExpiry: this.excessCardDetails.expiryDate,
        cardLine1: this.excessCardDetails.line1,
        cardLine2: this.excessCardDetails.line2,
        cardTown: this.excessCardDetails.town,
        cardCounty: this.excessCardDetails.county,
        cardPostcode: this.excessCardDetails.postcode
      }
     
      repairOptionsService.attemptExcessPaymentForGadget(paymentDetails)
        .then(response => {
          
          this.paymentResponse = response.data
          if (this.paymentResponse && this.paymentResponse.paymentSuccess === true) {
            this.paymentSuccess = true

            let opt = {
              ...this.selectedRepairOption,
              gadgetWebRef: gadgetId,
              claimWebRef: this.selectedClaim.id
            }

            repairOptionsService.setRepairOptionForGadget(opt)
              .then(response => {
                this.setRepairOptionResponse = response.data
                if (this.setRepairOptionResponse.success === true) {
                  this.setInstructions(this.setRepairOptionResponse.instructionsHTML)
                  this.loadSelectedClaim(this.selectedGadgetId)
                  this.$router.push({ path: '/myclaims/repairoptions/instructions' })
                } else {
                  this.errors.push('Set repair option error')
                }
              })
              .catch(() => {
                this.errors.push('Fatal error')
              })
          } else {
            let { paymentResponse } = this
            if (paymentResponse) {
              this.showPaymentAdvice =
                paymentResponse.paymentAdvice && paymentResponse.paymentAdvice !== ''
            } else {
              this.paymentResponse = { paymentAdvice: 'We are unable to process your payment.' }
              this.showPamentAdvice = true
            }
          }
        })
        .catch((err) => {
          this.errors.push('Fatal error')
        })
        .finally(() => { this.setLoading(false) })
    },
    payExcessSetRepairOptionMakeBooking (gadgetId) {
      this.setLoading(true)
      let paymentDetails = {
        claimWebReference: this.selectedClaim.id,
        gadgetWebReference: gadgetId,
        cardTypeId: this.excessCardDetails.provider,
        cardName: this.excessCardDetails.name,
        cardNumber: this.excessCardDetails.number,
        cardSecurityCode: this.excessCardDetails.code,
        cardExpiry: this.excessCardDetails.expiryDate,
        cardLine1: this.excessCardDetails.line1,
        cardLine2: this.excessCardDetails.line2,
        cardTown: this.excessCardDetails.town,
        cardCounty: this.excessCardDetails.county,
        cardPostcode: this.excessCardDetails.postcode
      }

      repairOptionsService.attemptExcessPaymentForGadget(paymentDetails)
        .then(response => {
          this.paymentResponse = response.data
          if (this.paymentResponse.paymentSuccess === true) {
            this.paymentSuccess = true

            let opt = {
              ...this.selectedRepairOption,
              gadgetWebRef: gadgetId,
              claimWebRef: this.selectedClaim.id
            }

            repairOptionsService.setRepairOptionForGadget(opt)
              .then(response => {
                this.setRepairOptionResponse = response.data
                if (this.setRepairOptionResponse.success === true) {
                  this.setInstructions(this.setRepairOptionResponse.instructionsHTML)
                  this.loadSelectedClaim(this.selectedGadgetId)

                  // make booking...
                  let setDatePayload = {
                    gadgetWebReference: this.selectedGadgetId,
                    bookingReference: this.bookingReference,
                    selectedDate: this.selectedBookingDate.dateObj,
                    overrideAddress: this.selectedAddress
                  }
                  repairOptionsService.setBookingDateAndChargeForGadget(setDatePayload)
                    .then(response => {
                      let { data } = response
                      if (data) {
                        let { booking, success } = data
                        this.booking = booking
                        if (success === true) {
                          this.loadSelectedClaim(this.selectedGadgetId)
                          this.$router.push({ path: '/myclaims/repairoptions/instructions' })
                        }
                      } else {
                        this.loadSelectedClaim(this.selectedGadgetId)
                        this.errors.push('Problem with booking')
                      }
                    })
                    .catch(error => {
                      this.errors.push('Fatal error')
                    })
                    .finally()
                } else {

                }
              })
              .catch(error => {
                this.errors.push('Fatal error')
              })
          } else {
            this.showPamentAdvice =
                            this.paymentResponse.paymentAdvice && this.paymentResponse.paymentAdvice != ''
          }
        })
        .catch(() => { this.errors.push('Fatal error') })
        .finally(() => { this.setLoading(false) })
    },
    setRepairOptionMakeBooking (gadgetId) {
      this.setLoading(true)

      let opt = {
        ...this.selectedRepairOption,
        gadgetWebRef: gadgetId,
        claimWebRef: this.selectedClaim.id
      }

      repairOptionsService.setRepairOptionForGadget(opt)
        .then(response => {
          this.setRepairOptionResponse = response.data
          if (this.setRepairOptionResponse.success == true) {
            this.setInstructions(this.setRepairOptionResponse.instructionsHTML)
            this.loadSelectedClaim(this.selectedGadgetId)

            // make booking...
            let setDatePayload = {
              gadgetWebReference: this.selectedGadgetId,
              bookingReference: this.bookingReference,
              selectedDate: this.selectedBookingDate.dateObj,
              overrideAddress: this.selectedAddress
            }
            repairOptionsService.setBookingDateAndChargeForGadget(setDatePayload)
              .then(response => {
                let { booking, success } = response.data
                this.booking = booking
                this.loadSelectedClaim(this.selectedGadgetId)
                if (success === true) {
                  this.$router.push({ path: '/myclaims/repairoptions/instructions' })
                } else {
                  this.errors.push('Problem with booking')
                }
              })
              .catch(() => {
                this.errors.push('Fatal error')
              })
              .finally()
          } else {
            this.errors.push('Set repair option error')
          }
        })
        .catch(() => {
          this.errors.push('Fatal error')
        })
    },
    populateCardDetailsFromClaimant () {
      if (this.claimant) {
        let { title, firstname, lastname } = this.claimant
        this.excessCardDetails.name = title + ' ' + firstname + ' ' + lastname

        let { line1, line2, city, county, postcode } = this.claimant.address
        this.excessCardDetails.line1 = line1
        this.excessCardDetails.line2 = line2
        this.excessCardDetails.city = city
        this.excessCardDetails.county = county
        this.excessCardDetails.postcode = postcode
      }
    }
  }
}
